<template>
	<div class="wj-manage">
		<el-header class="wj-header flex space-between" style="width: 100%; position: fixed; z-index: 111">
			<el-menu class="back" mode="horizontal"><el-menu-item @click="mywj()" class="menu-header-text"><i class="el-icon-arrow-left"></i> {{$t('main.MyQuestionnaire')}}</el-menu-item></el-menu>
			<el-menu :default-active="activeIndex" :active="activeIndex" class="el-menu-demo" mode="horizontal">
				<el-menu-item index="0" class="menu-header-text"><router-link :to="{ name: 'QuestionType', query: { id: 1 } }" tag="li">{{ $t('main.EditItem') }}</router-link></el-menu-item>
				<el-menu-item index="1" class="menu-header-text"><router-link :to="{ name: 'WjPub' }" tag="li">{{ $t('main.PublishProject') }}</router-link></el-menu-item>
				<el-menu-item index="2" class="menu-header-text"><router-link :to="{ name: 'WjStat' }" tag="li"> {{ $t('main.Dataecycling') }}</router-link></el-menu-item>
			</el-menu>
			<el-menu class="preview" mode="horizontal">
				<!-- <el-menu-item class="menu-header-text" @click="importData">导入</el-menu-item>
				<el-menu-item class="menu-header-text" @click="exportData">导出</el-menu-item> -->
				<el-menu-item @click="toPrev()" class="menu-header-text">{{$t('main.Preview')}}</el-menu-item>
			</el-menu>
		</el-header>
		<div style="padding-top: 60px;">
			<router-view></router-view>
		</div>
	</div>
</template>
<style lang="scss" scoped>
.wj-manage {
	position: absolute;
	width: 100%;
	height: 100%;
	overflow-y: auto;
	background-color: #fff;
	.wj-header {
		background-color: #fff;

		.menu-header-text {
			font-size: 18px;
			display: flex;
			align-items: baseline;
		}
	}
}

.el-input__inner {
	padding: 0px !important;
}
// .back{
//     border-bottom: 2px solid #4b94dc;
// }
</style>
<script>
export default {
	name: 'wjManage',
	components: {},
	data() {
		return {
			wid: 0,
			questionlist: [],
			activeIndex: '0'
		};
	},
	computed: {
	},
	watch: {
		'$route': {
			immediate: true, // 立即执行一次
			handler(to) {
				console.log('to.name', to.name)
				// 只有匹配到已知路由时才更新，否则保持原值
				if (to.name === 'QuestionType') {
					this.activeIndex = '0';
				} else if (to.name === 'WjPub' ||  to.name === 'PublishProject') {
					this.activeIndex = '1';
				} else if (['ItemStatistics', 'itemStatisticsCopy', 'dataAnalysis','DataReport', 'SourceAnalysis', 'AuditReport', 'CrossAnalysis'].includes(to.name)) {
					this.activeIndex = '2';
				} else if (to.name === 'Telecommunications') {
					if (to.path.includes('/wjmanage/wjpub/')) {
						this.activeIndex = '1';
					} else if (to.path === '/telecommunications') {
						this.activeIndex = '0';
					}
				} else if (to.name === 'DiscussPersonally') {
					if (to.path.includes('/wjmanage/wjpub/')) {
						this.activeIndex = '1';
					} else if (to.path === '/telecommunications') {
						this.activeIndex = '0';
					}
				}
			}
		}
	},
	mounted: function() {
		this.type = this.$route.query.type || 0;
		// console.log(this.wid)
	},
	methods: {
		importData() {},
		exportData() {},
		loadQuestionList() {
			let that = this;
			if (this.wid == null) {
				this.$alert(this.$t('main.ExitListPage'), this.$t('main.tip'), {
					confirmButtonText: this.$t('main.ok'),
					callback: action => {
						that.$router.push('/my');
					}
				});
				return 
			}
			let params = {
				that: this,
				url: `${this.$config.service.questionlist}?id=${that.wid}`,
				method: 'GET',
				data: {},
				cb(res) {
					if (res.code == 0) {
						// that.$router.push("/my");
						if (res.resultBody.tbExamPaper && res.resultBody.tbExamPaper != '') {
							let paper = JSON.parse(res.resultBody.tbExamPaper.paperjson);
							that.questionlist = paper.questionsList ? paper.questionsList : [];
						}
						that.$router.push('/my');
					}
				}
			};
			this.$util.request(params);
		},
		mywj() {
			this.wid = sessionStorage.getItem('wid');
			this.loadQuestionList();
		},
		toPrev() {
			if (!this.wid || this.wid == '0') {
				this.wid = sessionStorage.getItem('wid') || 'x';
			}
			window.location.href = '#/preview?tabPosition=computer&id=' + this.wid+'&isBank=true';
		}
	}
};
</script>
